<template>
  <div id="sidebar-btn">
    <v-btn
      block
      variant="elevated"
      rounded="sm"
      append-icon="mdi-plus"
      @click="createEvent"
      >Create
    </v-btn>
  </div>
  <AppointmentForm
    v-if="editStore.isEditMode"
    :event-id="editStore.editFormId"
    @close-form="doFormClose"
  />
</template>

<script setup>
import AppointmentForm from "./appointment/EventForm.vue";
import { useEditStore } from "./../../../stores/EditFormStore";
const editStore = useEditStore();

function doFormClose() {
  editStore.closeEditMode();
}

function createEvent() {
  editStore.setEditFormId(null);
  editStore.setIsCloneMode(false);
  editStore.setIsEditMode();
}
</script>

<style>
.appt-time {
  background-color: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  padding: 0 4px;
  align-items: center;
  font-weight: 500;
  margin-top: 2px;
  display: inline-block;
  margin-left: 4px;
}

.appt-vsheet {
  text-align: center;
  padding: 4px 0px;
}

.v-overlay__scrim {
  display: none;
}
/*
#sidebar-btn .v-col-sm-12 {
  padding: 4px 0px !important;
}

#sidebar-btn .v-col-sm-6 {
  padding: 4px 0px !important;
}

#sidebar-btn .v-card-text {
  padding: 16px 4px 10px;
}
*/
.appt-form-dialog {
  position: absolute;
  left: 4px;
  top: 66px;
  margin: 0px !important;
}

.success-form {
  font-size: 100px;
  color: green;
  text-align: center;
}

.success-form-text {
  color: black;
  font-weight: bold;
  font-size: 20px;
}
</style>
